import name from './name'

const selectSliceData = state => state[name]

const selectUserSettings = state => selectSliceData(state).userSettings

export {
  selectUserSettings
}
